import React from 'react'
import {UniLink, TertiaryButtonDark} from '../../../../core/components/unilink/index'
import {TextInput} from '../../../../core/components/input/index'

class ChangePassword extends React.PureComponent {
  constructor(props) {
    super(props)
    //const {user} = this.props
    this.state = {
      currentPassword: null,
      newPassword: null,
      verifyPassword: null,
      passwordChangeResults: {
        success: false,
        message: ''
      },
    }

    this.currentPasswordChange = this.currentPasswordChange.bind(this)
    this.newPasswordChange = this.newPasswordChange.bind(this)
    this.verifyPasswordChange = this.verifyPasswordChange.bind(this)
    this.submitPasswordChange = this.submitPasswordChange.bind(this)
  }

  currentPasswordChange(e) {
    this.setState({
      currentPassword: e.target.value,
      passwordChangeResults: {
        success: false,
        message: ''
      }
    })
  }
  newPasswordChange(e) {
    this.setState({
      newPassword: e.target.value,
      passwordChangeResults: {
        success: false,
        message: ''
      }
    })
  }
  verifyPasswordChange(e) {
    this.setState({
      verifyPassword: e.target.value,
      passwordChangeResults: {
        success: false,
        message: ''
      }
    })
  }
  submitPasswordChange() {
    const {currentPassword, newPassword, verifyPassword} = this.state
    const {postSaveChangePassword} = this.props

    if (currentPassword.length && newPassword === verifyPassword) {
      postSaveChangePassword(currentPassword, newPassword)
        .then((output) => {
          this.setState({
            passwordChangeResults: {
              success: true,
              message: output
            }
          })
        })
        .catch((output) => {
          this.setState({
            passwordChangeResults: {
              success: false,
              message: output.error_message
            }
          })
        })
    }
  }
  render() {
    const {currentPassword, newPassword, verifyPassword, passwordChangeResults} = this.state
    const {forgotPassword} = this.props
    const changePasswordEnabled = currentPassword && newPassword && verifyPassword && newPassword === verifyPassword
    const passwordChangeState = passwordChangeResults.success ? 'success' : 'fail'
    return (
      <div className='edit-profile__content'>
        <div className='account-settings'>
          <div className='edit-profile__block'>
            <h1 className='edit-profile__block-title'>Password</h1>
            <div className='edit-profile__block'>
              <div className='edit-profile__input-container'>
                <label
                  className='edit-profile__label'
                  htmlFor='currentpassword'>To update, re-enter your current password</label>
                <TextInput
                  type='password'
                  className='edit-profile__text-input'
                  placeholder='Current Password'
                  onChange={this.currentPasswordChange}
                  id='currentpassword' />
                <UniLink onClick={forgotPassword} className='edit-profile__forgot-password'>
                Forgot your password?
                </UniLink>
                <TextInput
                  type='password'
                  className='edit-profile__text-input'
                  onChange={this.newPasswordChange}
                  placeholder='New Password'
                />
                <TextInput
                  type='password'
                  className='edit-profile__text-input'
                  onChange={this.verifyPasswordChange}
                  placeholder='Verify Password'
                />
              </div>
              <div className='edit-profile__submit'>
                <TertiaryButtonDark
                  disabled={!changePasswordEnabled}
                  onClick={this.submitPasswordChange}
                  id='changepassword'
                  className='edit-profile__button'>
                Change Password
                </TertiaryButtonDark>
                {
                  passwordChangeResults.message.length
                    ? <span className={`edit-profile__result edit-profile__result--${passwordChangeState}`}>
                      {passwordChangeResults.message}
                    </span>
                    : null
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

export default ChangePassword



// WEBPACK FOOTER //
// ./src/domains/user/edit-profile/components/ChangePassword.js